import { render } from "./UserPermissionsOffcanvas.vue?vue&type=template&id=2f4c38ac&scoped=true"
import script from "./UserPermissionsOffcanvas.vue?vue&type=script&lang=js"
export * from "./UserPermissionsOffcanvas.vue?vue&type=script&lang=js"

import "./UserPermissionsOffcanvas.vue?vue&type=style&index=0&id=2f4c38ac&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4c38ac"]])

export default __exports__